// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2zkej","content":"LayoutSettings_content__krTGw"};